import { render, staticRenderFns } from "./BaseListLayout.vue?vue&type=template&id=67672ccc&scoped=true&"
import script from "./BaseListLayout.vue?vue&type=script&lang=js&"
export * from "./BaseListLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67672ccc",
  null
  
)

export default component.exports